import { Link } from "react-router-dom";
import LumebaType, { ProductModelColor, ProductModelType } from "@ltypes/product";
import './Lumeba.scss';
import { useTranslation } from "react-i18next";

type LumebaProps = {
    lumeba: LumebaType,
};

function Lumeba(props: LumebaProps) {

    const { t } = useTranslation();

    // return (
    //     <Link className="nostyle" to={`/m/${props.lumeba.id}/dashboard`}>
    //         <div className="lumeba-container">
    //             <div className="row lumeba-header">
    //                 <div className={`col-6 lumeba-header-left ${props.lumeba.is_connected ? 'active' : ''}`}>
    //                     <FaCircle size="0.5rem"/>
    //                     <span>{props.lumeba.is_connected ? 'ON' : 'OFF'}</span>
    //                 </div>
    //                 <div className="col-6 text-right">
    //                     v{props.lumeba.version.name}
    //                 </div>
    //             </div>
    //             <div className="lumeba-icon"></div>
    //             <div className="lumeba-infos">
    //                 <div className="row">
    //                     <div className="col-12">
    //                         <span className="lumeba-label">{props.lumeba.name}</span>
    //                     </div>
    //                     <div className="col-12">
    //                         <span className="lumeba-small">{props.lumeba.serial_number}</span>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </Link>
    // );

    return (
        <Link className="nostyle" to={`/m/${props.lumeba.id}/dashboard`}>
            <div className="lumeba-container">
                <div className={`lumeba-icon lmb-${props.lumeba.model.type == ProductModelType.LEGACY ? 'legacy' : props.lumeba.model.color == ProductModelColor.BLACK ? 'black' : props.lumeba.model.color == ProductModelColor.WHITE ? 'white' : props.lumeba.model.color == ProductModelColor.BLUE ? 'blue' : props.lumeba.model.color == ProductModelColor.PINK ? 'pink' : 'black'}`}></div>
                <div className="lumeba-infos">
                    <div className="lumeba-infos-header">
                        <span className="lumeba-infos-name">{props.lumeba.name}</span>
                        <span className={'lumeba-infos-state ' + (props.lumeba.is_connected ? 'online' : 'offline')}>{t(props.lumeba.is_connected ? 'text.online' : 'text.offline')}</span>
                    </div>
                    <span className="lumeba-infos-version">Version {props.lumeba.version.name}</span>
                </div>
            </div>
        </Link>
    );
}

export default Lumeba;
